import secureLocalStorage from "react-secure-storage";
import { sessionStorageKey } from "../consts";

export function getLocalAccessToken(): string | undefined {
    const session = JSON.parse(
        secureLocalStorage.getItem(sessionStorageKey) as string
    );

    if (session?.auth) {
        const { auth } = session;
        const { access } = auth;
        return access;
    }
}

export function getLocalRefreshToken(): string | undefined {
    const session = JSON.parse(
        secureLocalStorage.getItem(sessionStorageKey) as string
    );
    if (session?.auth) {
        const { auth } = session;
        const { refresh } = auth;
        return refresh;
    }
}

export function updateLocalAccessToken(accessToken: string) {
    const session = JSON.parse(
        secureLocalStorage.getItem(sessionStorageKey) as string
    );
    if (session) {
        const { auth } = session;
        const newAuth = { ...auth, access: accessToken };
        const newSessionWithAccessTokenRefreshed = {
            ...session,
            auth: newAuth,
        };
        secureLocalStorage.setItem(
            sessionStorageKey,
            JSON.stringify(newSessionWithAccessTokenRefreshed)
        );
        return;
    }
}

export async function deleteSession() {
    await secureLocalStorage.removeItem(sessionStorageKey);
}
